/**
 * Utility functions for handling dev routes
 */

/**
 * Checks if the current path is a dev route
 * @returns boolean indicating if the current path starts with /dev/
 */
export const isDevRoute = (): boolean => {
  return window.location.pathname.startsWith('/dev/');
};

/**
 * Preserves the dev route prefix when navigating to a new path
 * If the current path is a dev route, it will add the /dev/ prefix to the target path
 * @param path The target path to navigate to
 * @returns The path with /dev/ prefix if needed
 */
export const preserveDevRoute = (path: string): string => {
  // If path already starts with /dev/, return it as is
  if (path.startsWith('/dev/')) {
    return path;
  }
  
  // If current path is a dev route, add /dev/ prefix to the target path
  if (isDevRoute()) {
    // Extract the organization type (business or charity) from the current path
    const currentPath = window.location.pathname;
    const match = currentPath.match(/\/dev\/(business|charity)/);
    
    if (match && match[1]) {
      const orgType = match[1]; // business or charity
      
      // If the path starts with /business/ or /charity/, replace it with /dev/business/ or /dev/charity/
      if (path.startsWith(`/${orgType}/`)) {
        return `/dev${path}`;
      }
      
      // If the path doesn't include the org type, add the current org type
      return `/dev/${orgType}${path.startsWith('/') ? path : `/${path}`}`;
    }
    
    // Fallback: just add /dev/ prefix
    return `/dev${path.startsWith('/') ? path : `/${path}`}`;
  }
  
  // Not a dev route, return the path as is
  return path;
};
